import React, { useContext, useState } from 'react'
import UpdateWriterIPIForm from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterIpiUpdateRequestSidebar/UpdateWriterIPIForm'
import { StoresContext } from '@App/contexts'
import ConfirmationStep from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterRequestUpdateSidebar/ConfirmationStep'
import './index.scss'

interface SongwriterIpiUpdateRequestSidebarProps {
    selectedWriterIpiNumber: string | undefined
    selectedWriterIpId: number
    closeSidebar: () => void
    onBack?: () => void
}

const SongwriterIpiUpdateRequestSidebar = ({
    selectedWriterIpId,
    selectedWriterIpiNumber,
    closeSidebar,
    onBack,
}: SongwriterIpiUpdateRequestSidebarProps) => {
    const { songwriterWriterSearchStore, popupStore, preloaderStore } = useContext(StoresContext)
    const [showConfirm, setShowConfirm] = useState(false)

    const goBack = () => (onBack ? onBack() : closeSidebar())

    const onSubmit = (newIpiNumber: string) => {
        preloaderStore.openTransparentPreloader(true)
        songwriterWriterSearchStore
            .submitWriterIpiUpdateRequest(selectedWriterIpId, newIpiNumber)
            .then(() => setShowConfirm(true))
            .catch((error) => popupStore.setAlertData(error.message, true))
            .finally(() => preloaderStore.openTransparentPreloader(false))
    }

    return (
        <div className="songwriter-request-update-wrapper">
            {showConfirm ? (
                <ConfirmationStep closeSidebar={closeSidebar} />
            ) : (
                <UpdateWriterIPIForm onBack={goBack} onSubmit={onSubmit} currentIpiNumber={selectedWriterIpiNumber} />
            )}
        </div>
    )
}

export default SongwriterIpiUpdateRequestSidebar
